module.exports = __webpack_public_path__ + "static/img/bzzx1.6040ddb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bzzx1.png
// module id = XG96
// module chunks = 2